import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { PageLoader } from '@cfm-media/pwa-ui-components';

import { About } from './pages/about';
import { AirportParking } from './pages/airport-parking';
import { AppShell } from './utils/app-shell';
import { Contact } from './pages/contact';
import { DataProtection } from './pages/data-protection';
import { Documents } from './pages/documents';
import { EntryConditions } from './pages/entry-conditions';
import { Excursions } from './pages/excursions';
import { FlightDetails } from './pages/flight-detail';
import { Home } from './pages/home';
import { HotelDetails } from './pages/hotel-detail';
import { Imprint } from './pages/imprint';
import { Insurance } from './pages/insurance';
import { LimousineService } from './pages/limousine-service';
import { Login } from './pages/login';
import { Map } from './pages/map';
import { NotFound } from './pages/not-found';
import { Payment } from './pages/payment';
import { PeopleAndPlaces } from './pages/people-and-places';
import { Protected, Public } from './components/guards';
import { RentalCar } from './pages/rental-car';
import { Sitemap } from './pages/sitemap';
import { TermsAndConditions } from './pages/terms-and-conditions';
import { Transfer } from './pages/transfer';
import { Upgrades } from './pages/upgrades';
import { Weather } from './pages/weather';
import { urls } from './urls';
import { usePwaInstallationTracking } from './hooks/usePwaInstallationTracking';
import { useTrackPageView } from './hooks/useTrackPageView';

export function App() {
  usePwaInstallationTracking();

  useTrackPageView();

  return (
    <AppShell scrollOnNavigate>
      <Suspense
        fallback={
          <PageLoader
            overlay
            shadow="shadow-lg"
            variant="fixed"
            info="Einen Moment bitte"
          />
        }
      >
        {/* prettier-ignore */}
        <Routes>
          {/* login */}
          <Route path={urls.login} element={<Public component={Login} hideSidebar />} />

          {/* logged in */}
          <Route path={urls.home} element={<Protected component={Home} />} />
          <Route path={urls.hotelDetails} element={<Protected component={HotelDetails} />} />
          <Route path={`${urls.hotelDetails}/:serviceIndex`} element={<Protected component={HotelDetails} />} />
          <Route path={urls.flightDetails} element={<Protected component={FlightDetails} />} />
          <Route path={urls.contact} element={<Protected component={Contact} />} />
          <Route path={urls.payment} element={<Protected component={Payment} />} />
          <Route path={urls.documents} element={<Protected component={Documents} />} />
          <Route path={urls.entryConditions} element={<Protected component={EntryConditions} />} />
          <Route path={urls.sitemap} element={<Protected component={Sitemap} />} />
          <Route path={urls.weather} element={<Protected component={Weather} />} />
          <Route path={urls.transfer} element={<Protected component={Transfer} />} />
          <Route path={urls.map} element={<Protected component={Map} />} />
          <Route path={urls.insurance} element={<Protected component={Insurance} />} />

          <Route path={urls.upgrades} element={<Protected component={Upgrades} />} />
          <Route path={urls.rentalCar} element={<Protected component={RentalCar} />} />
          <Route path={urls.peopleAndPlaces} element={<Protected component={PeopleAndPlaces} />} />
          <Route path={urls.airportParking} element={<Protected component={AirportParking} />} />
          <Route path={urls.limousineService} element={<Protected component={LimousineService} />} />

          <Route path={urls.excursions.index + '/*'} element={<Protected component={Excursions} />} />

          {/* legal pages */}
          <Route path={urls.about} element={<Public component={About} />} />
          <Route path={urls.imprint} element={<Public component={Imprint} />} />
          <Route path={urls.dataProtection} element={<Public component={DataProtection} />} />
          <Route path={urls.termsAndConditions} element={<Public component={TermsAndConditions} />} />

          {/* Default */}
          <Route path="*" element={<Public component={NotFound} />} />
        </Routes>
      </Suspense>
    </AppShell>
  );
}
